import { render, staticRenderFns } from "./CarouselFormatIcon.vue?vue&type=template&id=ad5f3a28&scoped=true"
import script from "./CarouselFormatIcon.vue?vue&type=script&lang=js"
export * from "./CarouselFormatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5f3a28",
  null
  
)

export default component.exports